import React from 'react'
import { Redirect } from 'react-router-dom'
import {LANDINGPAGE} from '../../src/utils/constants'
var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

const RedirectPage = () => {
  return <Redirect to={`/${LANDINGPAGE}`} />
}

export default RedirectPage
